/* eslint-disable */
import { ArrowLeft } from 'lucide-react';
import SelectPicker from 'rsuite/SelectPicker';
import { Button } from '@/Components/ui/button';

const DrillDownButtons = (props) => {
    const {
        buttonList = [],
        drillDownView,
        setDrillDownView,
        onButtonClick,
        virtulized = false,
        isTransparent = true,
        handleBack = () => { },
    } = props;

    const handleButtonClick = (button) => {
        if (onButtonClick) {
            onButtonClick(button);
        }
    };

    const handleSelectChange = (val) => {
        setDrillDownView({ ...drillDownView, selectedValue: val });
    };

    return (
        <div className={`flex items-center gap-2 ${!isTransparent ? 'bg-white/95 backdrop-blur-sm px-4 py-2 rounded-xl shadow-lg border border-gray-100' : ''}`}>
            {drillDownView?.show ? (
                <>
                    <Button
                        onClick={handleBack}
                        className='bg-[#F1F5F9] hover:bg-[#E2E8F0] p-2'
                    >
                        <div className='bg-white rounded p-1'>
                            <ArrowLeft size={16} className='text-black' strokeWidth={2} />
                        </div>
                    </Button>
                    <div className='flex items-center gap-2 text-sm font-medium'>
                        {drillDownView?.icon} {drillDownView?.label}
                    </div>
                    <SelectPicker
                        data={drillDownView?.data}
                        value={drillDownView?.selectedValue}
                        onChange={handleSelectChange}
                        placeholder={drillDownView?.placeholder || 'Select'}
                        className='w-[200px]'
                        menuStyle={
                            {
                                zIndex: 1000,
                                width: '400px'
                            }
                        }
                        virtualized={virtulized}
                    />
                    {props.children}
                    {buttonList?.map((button) => {
                        if (button?.value !== drillDownView?.value) {
                            return (
                                <div
                                    onClick={() => handleButtonClick(button)}
                                    key={button?.value}
                                    className='flex items-center gap-2 bg-yellow-400 px-3 py-2 rounded-md text-sm font-medium cursor-pointer hover:bg-yellow-500 transition-colors'
                                >
                                    {button?.icon} {button?.label}
                                </div>
                            );
                        }
                        return null;
                    })}
                </>
            ) : (
                <>
                    {buttonList?.map((button) => (
                        <Button
                            key={button?.value}
                            onClick={() => handleButtonClick(button)}
                            className='flex px-3 text-black text-sm py-2 items-center gap-2 bg-yellow-400 hover:bg-yellow-500 transition-colors shadow-md'
                        >
                            {button?.icon}
                            {button?.label}
                        </Button>
                    ))}
                </>
            )}
        </div>
    );
};

export default DrillDownButtons;
